<template>
  <div class="dashboard">
    <!-- Header with Controls -->
    <div class="dashboard-header">
      <h1>SOULMAINT Dashboard</h1>
      <div class="controls">
        <button @click="refreshData" :disabled="loading" class="refresh-btn">
          🔄 {{ loading ? 'Refreshing...' : 'Refresh' }}
        </button>
        <!-- <button @click="exportData" class="export-btn">📊 Export</button> -->
        <span class="last-update">Last updated: {{ lastUpdate }}</span>
      </div>
    </div>

    <!-- Error Message -->
    <div v-if="error" class="error-message">
      ⚠️ {{ error }}
    </div>

    <!-- Loading Animation -->
    <div v-if="loading" class="loading-container">
      <div class="loading-spinner"></div>
      <p>Loading dashboard data...</p>
    </div>

    <!-- Enhanced Stats Grid -->
    <div v-else class="enhanced-stats-grid">
      <!-- Row 1: Core Metrics -->
      <div class="metric-card main-card" :class="getTrendClass('assets')">
        <div class="metric-header">
          <span class="metric-icon">🏭</span>
          <span class="metric-trend">↗️ +5%</span>
        </div>
        <h3>Total Assets</h3>
        <p class="metric-value">{{ metrics.totalAssets }}</p>
        <p class="metric-subtext">Active equipment</p>
      </div>

      <div class="metric-card main-card" :class="getPriorityClass('open')">
        <div class="metric-header">
          <span class="metric-icon">📋</span>
          <!-- <span class="metric-badge">{{ metrics.highPriorityWO }} High</span> -->
        </div>
        <h3>Open Work Orders</h3>
        <p class="metric-value">{{ metrics.openWorkOrders }}</p>
        <p class="metric-subtext">{{ metrics.overdueWO }} overdue</p>
      </div>

      <div class="metric-card main-card positive">
        <div class="metric-header">
          <span class="metric-icon">✅</span>
          <span class="metric-trend">📈 {{ metrics.completionRate }}%</span>
        </div>
        <h3>Closed Work Orders</h3>
        <p class="metric-value">{{ metrics.closedWorkOrders }}</p>
        <p class="metric-subtext">Completion rate</p>
      </div>

      <div class="metric-card main-card warning">
        <div class="metric-header">
          <span class="metric-icon">⚡</span>
          <span class="metric-trend">🔄 {{ metrics.breakdownWorkOrders }}</span>
        </div>
        <h3>Breakdown Maintenance</h3>
        <p class="metric-value">{{ metrics.breakdownWorkOrders }}</p>
        <p class="metric-subtext">Reactive work</p>
      </div>

      <!-- Row 2: Additional Metrics -->
      <div class="metric-card sub-card">
        <h4>🛡️ Preventive</h4>
        <p class="sub-value">{{ metrics.preventiveMaintenance }}</p>
      </div>

      <div class="metric-card sub-card">
        <h4>⏱️ Avg. Completion</h4>
        <p class="sub-value">{{ metrics.avgCompletionTime }} days</p>
      </div>

      <div class="metric-card sub-card">
        <h4>📈 Efficiency</h4>
        <p class="sub-value">{{ metrics.completionRate }}%</p>
      </div>

      <div class="metric-card sub-card">
        <h4>⏰ Overdue</h4>
        <p class="sub-value">{{ metrics.overdueWO }}</p>
      </div>
    </div>

    <!-- Charts Section -->
    <div v-if="!loading" class="charts-section">
      <!-- Work Order Trend Chart -->
      <div class="chart-container large">
        <div class="chart-header">
         
        </div>
       <!-- Charts Section -->
<div v-if="!loading" class="charts-section">
  <!-- Work Order Status Pie Chart -->
  <div class="chart-container">
    <h3>Work Order Status</h3>
    <div class="pie-chart-container">
      <div class="pie-chart-wrapper">
        <canvas ref="statusChart" width="200" height="200"></canvas>
      </div>
      <div class="pie-legend">
        <div class="legend-item">
          <span class="legend-dot open"></span>
          <span class="legend-label">Open: {{ metrics.openWorkOrders }} ({{ ((metrics.openWorkOrders / totalWorkOrders) * 100).toFixed(1) }}%)</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot closed"></span>
          <span class="legend-label">Closed: {{ metrics.closedWorkOrders }} ({{ ((metrics.closedWorkOrders / totalWorkOrders) * 100).toFixed(1) }}%)</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Work Type Distribution Pie Chart -->
  <div class="chart-container">
    <h3>Work Type Distribution</h3>
    <div class="pie-chart-container">
      <div class="pie-chart-wrapper">
        <canvas ref="typeChart" width="200" height="200"></canvas>
      </div>
      <div class="pie-legend">
        <div class="legend-item">
          <span class="legend-dot preventive"></span>
          <span class="legend-label">Preventive: {{ metrics.preventiveMaintenance }} ({{ ((metrics.preventiveMaintenance / totalWorkOrders) * 100).toFixed(1) }}%)</span>
        </div>
        <div class="legend-item">
          <span class="legend-dot breakdown-type"></span>
          <span class="legend-label">Breakdown: {{ metrics.breakdownWorkOrders }} ({{ ((metrics.breakdownWorkOrders / totalWorkOrders) * 100).toFixed(1) }}%)</span>
        </div>
      </div>
    </div>
  </div>
</div>
</div>


  <!-- Work Type Distribution Pie Chart -->
 

      <!-- Priority Distribution
      <div class="chart-container">
        <h3>Priority Distribution</h3>
        <div class="priority-chart">
          <div v-for="item in metrics.priorityDistribution" :key="item.priority" class="priority-item">
            <div class="priority-bar">
              <div 
                class="priority-fill" 
                :style="{ 
                  width: (item.count / Math.max(...metrics.priorityDistribution.map(p => p.count))) * 80 + '%',
                  backgroundColor: item.color 
                }"
              ></div>
              <span class="priority-count">{{ item.count }}</span>
            </div>
            <span class="priority-label">{{ item.priority }}</span>
          </div>
        </div>
      </div> -->

      <!-- Work Type Distribution -->
      <!-- <div class="chart-container large">
        <h3>Work Type Distribution</h3>
        <div class="worktype-chart">
          <div v-for="item in metrics.workTypeDistribution" :key="item.type" class="worktype-item">
            <div class="worktype-color" :style="{ backgroundColor: item.color }"></div>
            <span class="worktype-label">{{ item.type }}</span>
            <span class="worktype-count">{{ item.count }}</span>
          </div>
        </div>
      </div> -->

        <!-- Top Assets
        <div class="chart-container">
          <h3>Top Assets - Most Work Orders</h3>
          <div class="top-assets">
            <div v-for="(asset, index) in metrics.topAssets" :key="asset.assetName" class="asset-item">
              <span class="asset-rank">#{{ index + 1 }}</span>
              <div class="asset-info">
                <span class="asset-name">{{ asset.assetName }}</span>
                <span class="asset-details">{{ asset.woCount }} WOs • {{ asset.downtime }}h downtime</span>
              </div>
              <div class="asset-bar">
                <div class="asset-bar-fill" :style="{ width: (asset.woCount / 15) * 100 + '%' }"></div>
              </div>
            </div>
          </div>
        </div> -->
    </div>

    <div v-if="hasRole(['super_admin', 'admin', 'manager'])" class="quick-actions">
  <h3 >Quick Actions</h3>
  <div class="action-buttons">

    <!-- 🔹 Work Orders Dropdown -->
    <div class="dropdown">
      <button
        class="action-btn primary dropdown-toggle"
        type="button"
        id="workOrdersDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        🧾 Work Orders
      </button>
      <ul class="dropdown-menu enhanced-dropdown-menu" aria-labelledby="workOrdersDropdown">
        <!-- <li><router-link to="/workorders/create" class="dropdown-item enhanced-dropdown-item">➕ Create Work Order</router-link></li> -->
        <li><router-link to="/reports/openwo" class="dropdown-item enhanced-dropdown-item">📋  Open Work Orders</router-link></li>
        <li><router-link to="/reports/closedwo" class="dropdown-item enhanced-dropdown-item">✅ View Closed Work Orders</router-link></li>
      </ul>
    </div>

    <!-- 🔹 Assets Dropdown -->
    <div class="dropdown">
      <button
        class="action-btn secondary dropdown-toggle"
        type="button"
        id="assetsDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        🏭 Assets
      </button>
      <ul class="dropdown-menu enhanced-dropdown-menu" aria-labelledby="assetsDropdown">
        <!-- <li><router-link to="/assets/view" class="dropdown-item enhanced-dropdown-item">🏗️ View All Assets</router-link></li> -->
        <li><router-link to="/reports/assets-by-site" class="dropdown-item enhanced-dropdown-item">Assets by Site</router-link></li>
        <li><router-link to="/reports/assets-by-department" class="dropdown-item enhanced-dropdown-item">Assets by Department</router-link></li>
        <li><router-link to="/reports/assets-by-location" class="dropdown-item enhanced-dropdown-item">Assets by Location</router-link></li>
        <li><router-link to="/reports/assets-by-category" class="dropdown-item enhanced-dropdown-item">Assets by Category</router-link></li>
      </ul>
    </div>

  </div>
</div>

  </div>
</template>

<script>
import { ref, onMounted, computed, watch, nextTick } from 'vue'
import axios from 'axios'
import { API_BASE_URL } from '@/config';
import Chart from 'chart.js/auto'

export default {
  name: 'Dashboard',
  setup() {
    const metrics = ref({
      totalAssets: 0,
      openWorkOrders: 0,
      closedWorkOrders: 0,
      breakdownWorkOrders: 0,
      totalWorkOrders: 0,
      preventiveMaintenance: 0,
      highPriorityWO: 0,
      mediumPriorityWO: 0,
      lowPriorityWO: 0,
      overdueWO: 0,
      completionRate: 0,
      avgCompletionTime: 0,
      weeklyTrend: [],
      priorityDistribution: [],
      workTypeDistribution: [],
      topAssets: []
    })


    const hasRole = (roles) => {
      const userData = localStorage.getItem('user');
      if (!userData) return false;
      
      const user = JSON.parse(userData);
      const userRoles = user?.roles || [];
      
      return roles.some(role => userRoles.includes(role));
    }
    const loading = ref(true)
    const error = ref(null)
    const lastUpdate = ref('Never')
    const statusChart = ref(null)
    const typeChart = ref(null)

    let statusChartInstance = null
    let typeChartInstance = null

    // Computed properties
    const totalWorkOrders = computed(() => metrics.value.openWorkOrders + metrics.value.closedWorkOrders)

    // Chart rendering function
    const renderCharts = () => {
      if (!statusChart.value || !typeChart.value) return
      
      // Destroy previous charts if they exist
      if (statusChartInstance) {
        statusChartInstance.destroy()
      }
      if (typeChartInstance) {
        typeChartInstance.destroy()
      }
      
      // Work Order Status Chart
      const statusCtx = statusChart.value.getContext('2d')
      statusChartInstance = new Chart(statusCtx, {
        type: 'pie',
        data: {
          labels: ['Open', 'Closed'],
          datasets: [{
            data: [metrics.value.openWorkOrders, metrics.value.closedWorkOrders],
            backgroundColor: ['#f39c12', '#27ae60'],
            borderWidth: 0,
            borderColor: '#fff'
          }]
        },
        options: {
          responsive: false,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const total = context.dataset.data.reduce((a, b) => a + b, 0)
                  const percentage = ((context.parsed / total) * 100).toFixed(1)
                  return `${context.label}: ${context.parsed} (${percentage}%)`
                }
              }
            }
          }
        }
      })
      
      // Work Type Distribution Chart
      const typeCtx = typeChart.value.getContext('2d')
      const otherWorkOrders = totalWorkOrders.value - metrics.value.preventiveMaintenance - metrics.value.breakdownWorkOrders
      
      typeChartInstance = new Chart(typeCtx, {
        type: 'pie',
        data: {
          labels: ['Preventive', 'Breakdown'],
          datasets: [{
            data: [metrics.value.preventiveMaintenance, metrics.value.breakdownWorkOrders],
            backgroundColor: ['#3498db', '#e74c3c'],
            borderWidth: 0,
            borderColor: '#fff'
          }]
        },
        options: {
          responsive: false,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const total = context.dataset.data.reduce((a, b) => a + b, 0)
                  const percentage = ((context.parsed / total) * 100).toFixed(1)
                  return `${context.label}: ${context.parsed} (${percentage}%)`
                }
              }
            }
          }
        }
      })
    }

    // Methods
    const fetchDashboardData = async () => {
      try {
        loading.value = true
        error.value = null
        
        const API_DASHBOARD_URL = `${API_BASE_URL}/api/dashboard/metrics`;
        console.log('Fetching enhanced dashboard data...')
        
        const response = await axios.get(API_DASHBOARD_URL)
        
        if (response.data.success) {
          metrics.value = response.data.data
          lastUpdate.value = new Date().toLocaleTimeString()
          console.log('Enhanced data loaded:', metrics.value)
        }
      } catch (err) {
        error.value = 'Backend connection failed. Using demo data. Error: ' + err.message
        // Fallback to basic mock data
        metrics.value = {
          totalAssets: 156,
          openWorkOrders: 23,
          closedWorkOrders: 89,
          breakdownWorkOrders: 15,
          totalWorkOrders: 127,
          preventiveMaintenance: 45,
          highPriorityWO: 8,
          mediumPriorityWO: 10,
          lowPriorityWO: 5,
          overdueWO: 5,
          completionRate: 72,
          avgCompletionTime: 3.2,
          weeklyTrend: [],
          priorityDistribution: [],
          workTypeDistribution: [],
          topAssets: []
        }
        lastUpdate.value = new Date().toLocaleTimeString()
      } finally {
        loading.value = false
      }
    }

    const refreshData = () => {
      fetchDashboardData()
    }

    const exportData = () => {
      const dataStr = JSON.stringify(metrics.value, null, 2)
      const dataBlob = new Blob([dataStr], { type: 'application/json' })
      const url = URL.createObjectURL(dataBlob)
      const link = document.createElement('a')
      link.href = url
      link.download = `dashboard-export-${new Date().toISOString().split('T')[0]}.json`
      link.click()
      URL.revokeObjectURL(url)
      alert('Dashboard data exported successfully!')
    }

    const getTrendClass = (type) => {
      const trends = {
        assets: 'positive',
        open: 'warning',
        closed: 'positive',
        breakdown: 'warning'
      }
      return trends[type] || ''
    }

    const getPriorityClass = (type) => {
      if (type === 'open' && metrics.value.highPriorityWO > 5) return 'critical'
      return 'warning'
    }

    const createWorkOrder = () => {
      alert('Navigate to Work Order creation page...')
      // this.$router.push('/workorders/create')
    }

    const viewAssets = () => {
      alert('Navigate to Assets page...')
      // this.$router.push('/assets')
    }

    const generateReport = () => {
      alert('Generating maintenance report...')
    }

    const schedulePM = () => {
      alert('Navigate to PM scheduling...')
      // this.$router.push('/pm-schedule')
    }

    // Watch for metrics changes and render charts
    watch(metrics, () => {
      if (!loading.value) {
        nextTick(() => {
          renderCharts()
        })
      }
    }, { deep: true })

    // Auto-refresh every 2 minutes
    onMounted(() => {
      fetchDashboardData().then(() => {
        nextTick(() => {
          renderCharts()
        })
      })
      setInterval(fetchDashboardData, 2 * 60 * 1000)
    })

    return {
      metrics,
      loading,
      error,
      lastUpdate,
      totalWorkOrders,
      statusChart,
      typeChart,
      refreshData,
      exportData,
      getTrendClass,
      getPriorityClass,
      createWorkOrder,
      viewAssets,
      generateReport,
      schedulePM,
      hasRole
    }
  }
}
</script>

<style scoped>
.dashboard {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 15px;
}

.dashboard-header h1 {
  color: #2c3e50;
  margin: 0;
}

.controls {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.refresh-btn, .export-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}

.refresh-btn {
  background: #3498db;
  color: white;
}

.refresh-btn:disabled {
  background: #bdc3c7;
  cursor: not-allowed;
}

.export-btn {
  background: #27ae60;
  color: white;
}

.refresh-btn:hover:not(:disabled), .export-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

.last-update {
  color: #7f8c8d;
  font-size: 0.9em;
}

/* Enhanced Stats Grid */
.enhanced-stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

@media (max-width: 1200px) {
  .enhanced-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .enhanced-stats-grid {
    grid-template-columns: 1fr;
  }
}

.metric-card {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.metric-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0,0,0,0.15);
}

.main-card {
  border-left: 6px solid #3498db;
}

.main-card.positive {
  border-left-color: #27ae60;
}

.main-card.warning {
  border-left-color: #f39c12;
}

.main-card.critical {
  border-left-color: #e74c3c;
  animation: pulse 2s infinite;
}

.sub-card {
  border-left: 4px solid #95a5a6;
  text-align: center;
}

.metric-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.metric-icon {
  font-size: 2rem;
}

.metric-trend, .metric-badge {
  font-size: 0.8em;
  padding: 4px 8px;
  border-radius: 12px;
  background: #ecf0f1;
  font-weight: bold;
}

.metric-badge {
  background: #e74c3c;
  color: white;
}

.metric-card h3 {
  margin: 0 0 10px 0;
  font-size: 1rem;
  color: #2c3e50;
}

.metric-value {
  font-size: 2.5rem;
  font-weight: bold;
  margin: 0;
  color: #2c3e50;
}

.metric-subtext {
  margin: 5px 0 0 0;
  font-size: 0.9em;
  color: #7f8c8d;
}

.sub-card h4 {
  margin: 0 0 10px 0;
  font-size: 0.9rem;
  color: #7f8c8d;
}

.sub-value {
  font-size: 1.8rem;
  font-weight: bold;
  margin: 0;
  color: #2c3e50;
}

/* Charts Section */
.charts-section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

@media (max-width: 1200px) {
  .charts-section {
    grid-template-columns: 1fr;
  }
}

.chart-container {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.chart-container.large {
  grid-column: 1 / -1;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}

.chart-header h3 {
  margin: 0;
  color: #2c3e50;
}

.chart-legend {
  display: flex;
  gap: 15px;
  font-size: 0.9em;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.legend-color.created { background: #3498db; }
.legend-color.open { background: #f39c12; }
.legend-color.closed { background: #27ae60; }

/* Trend Chart */
.trend-chart {
  display: flex;
  justify-content: space-between;
  align-items: end;
  height: 200px;
  gap: 10px;
}

.trend-day {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.trend-bars {
  display: flex;
  align-items: end;
  gap: 2px;
  height: 150px;
  width: 100%;
}

.bar {
  flex: 1;
  border-radius: 2px 2px 0 0;
  transition: all 0.3s ease;
  min-height: 5px;
}

.bar.created { background: #3498db; }
.bar.open { background: #f39c12; }
.bar.closed { background: #27ae60; }

.bar:hover {
  opacity: 0.8;
}

.trend-label {
  margin-top: 10px;
  font-size: 0.8em;
  color: #7f8c8d;
  text-align: center;
}

/* Priority Chart */
.priority-chart {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.priority-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.priority-bar {
  flex: 1;
  background: #ecf0f1;
  height: 30px;
  border-radius: 15px;
  position: relative;
  overflow: hidden;
}

.priority-fill {
  height: 100%;
  border-radius: 15px;
  transition: width 0.5s ease;
}

.priority-count {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-weight: bold;
  color: white;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.5);
}

.priority-label {
  width: 60px;
  font-weight: bold;
  color: #2c3e50;
}

/* Work Type Chart */
.worktype-chart {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.worktype-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border-radius: 6px;
  background: #f8f9fa;
}

.worktype-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
}

.worktype-label {
  flex: 1;
  font-weight: 500;
}

.worktype-count {
  font-weight: bold;
  color: #2c3e50;
}

/* Top Assets */
.top-assets {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.asset-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 8px;
}

.asset-rank {
  background: #3498db;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.9em;
}

.asset-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.asset-name {
  font-weight: bold;
  color: #2c3e50;
}

.asset-details {
  font-size: 0.8em;
  color: #7f8c8d;
}

.asset-bar {
  flex: 0 0 100px;
  height: 8px;
  background: #ecf0f1;
  border-radius: 4px;
  overflow: hidden;
}

.asset-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #3498db, #2980b9);
  border-radius: 4px;
  transition: width 0.5s ease;
}

/* Quick Actions */
.quick-actions {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.quick-actions h3 {
  margin: 0 0 15px 0;
  color: #2c3e50;
}

.action-buttons {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.action-btn {
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  flex: 1;
  min-width: 150px;
}

.action-btn.primary {
  background: #3498db;
  color: white;
}

.action-btn.secondary {
  background: #ecf0f1;
  color: #2c3e50;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

/* Loading Animation */
.loading-container {
  text-align: center;
  padding: 60px 20px;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #ecf0f1;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

/* Error Message */
.error-message {
  background: #ffeaa7;
  color: #e17055;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  border-left: 4px solid #fdcb6e;
}

/* Pie Charts */
.pie-chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.pie-chart-wrapper {
  width: 200px;
  height: 200px;
}

.pie-legend {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px;
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.legend-dot.open { background: #f39c12; }
.legend-dot.closed { background: #27ae60; }
.legend-dot.breakdown { background: #e74c3c; }
.legend-dot.preventive { background: #3498db; }
.legend-dot.breakdown-type { background: #e74c3c; }
.legend-dot.other { background: #95a5a6; }

.legend-label {
  font-size: 0.9em;
  color: #2c3e50;
}

</style>